module.exports = __webpack_public_path__ + "img/icon-512x512.fed6ef73.png";